import React, { useState, useEffect } from "react";

function NewsPopUp({ notice=false }) {
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    const popupStatus = localStorage.getItem("popup");
    if (popupStatus === "0") {
      setShowPopup(false);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('popup', '0');
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="cdk-overlay-container">
      <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
      <div className="cdk-global-overlay-wrapper" dir="ltr" style={{ justifyContent: 'center', alignItems: 'center' }}>
        <div id="cdk-overlay-2" className="cdk-overlay-pane dialog-panel" style={{ position: 'static' }}>
          <div className="popup" id="dialog-2">
            <div className="popup__header"></div>
            <div className="popup__content">
              <div className="pop-wrap promotion-pop new ng-trigger ng-trigger-popWrapTriggerAni ani show ">
                <a className="btn-close" onClick={handleClose}>
                  <span className="item-icon" style={{ backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-cross-type01.svg?v=1743412106882")' }} />
                </a>

                <div className="pop-title">
                  <h3>【📢 জরুরি নোটিশ – প্ল্যাটফর্ম মেইনটেন্যান্স 📢】</h3>
                </div>
                <div className="pop-inner content-style">
                  <div>{notice}</div>
                </div>
              </div>

              <div className="pop-bg" style={{ display: 'block' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsPopUp;
